module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M32 2c0-1.106-.894-2-2-2H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2zM18.016 25.12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zM18 17.776v1.344c0 .552-.432.88-.984.88h-2c-.554 0-1.016-.328-1.016-.88v-3c0-1.106.266-2.12 1.516-2.12h1.5c.552 0 .984-.328.984-.88v-2c0-.554-.432-1.12-.984-1.12h-2a1 1 0 0 0-1 1c0 .278-.188 1-1 1h-2c-.75 0-1.008-.39-.918-.938.476-2.836 2.95-4.972 5.918-4.972 3.308 0 5.992 2.706 5.992 6.014 0 2.606-2.008 4.848-4.008 5.672z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/question-1.js
// module id = 1360
// module chunks = 14